/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// liobraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { viewAnalytics } from 'state/actions/embedsState/embeds_status';
// component
import AnalyticsCTA from 'material/ctas/analytics/analytics';



/* ========== ~~~~~~~~~~ CTA : ANALYTICS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ appStatus, modalStatus, embedsState }) => ({
	currentPage: appStatus.currentPage,
    embedUUID: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedUUID,
    modalVisible: modalStatus.visible,
    changeDetected: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedChangeDetected ||
            embedsState.embedManagementState.contentStatus.contentChangeDetected
});

// map actions
const mapDispatchToProps = dispatch => ({
	moveToPage: (location) => {
		dispatch(updatePageDetails(location));
    	dispatch(changePage(location))
    },
    viewAnalytics: embedUUID => dispatch(viewAnalytics(embedUUID))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(AnalyticsCTA);
